import { userConstants } from "../constants/user.constants";

const initialState = {
    selectedProductType: sessionStorage.getItem("productTypeSelected") || "all",

};

export function ProductTypeFilter(state = initialState, action) {
    switch (action.type) {
        case userConstants.SET_PRODUCT_TYPE_FILTER:
            sessionStorage.setItem("productTypeSelected", action.payload);

            return {
                ...state,
                selectedProductType: action.payload,
            };

        default:
            return state;
    }
}